// extracted by mini-css-extract-plugin
export var md = "_33-4";
export var semantic = "_33-5";
export var sm = "_33-3";
export var text = "_33-6";
export var toggleInput = "_33-0";
export var toggleSwitch = "_33-1";
export var xs = "_33-2";